import React from 'react'
import hager_icon from 'src/Libs/flow/images/hager-icon-72x72.png'

interface MarkerProps {
  lat: number
  lng: number
}

/**
 * Marker which symbolizes an installation
 */
export const Marker: React.FC<MarkerProps> = ({ lat, lng }) => {
  return (
    <img
      style={{ borderRadius: `4px` }}
      alt="Map icon"
      src={hager_icon}
      width={40}
      height={40}
      // @ts-expect-error lat&lng necessary for map but img doesn't know these props
      // eslint-disable-next-line react/no-unknown-property
      lat={lat}
      // eslint-disable-next-line react/no-unknown-property
      lng={lng}
    />
  )
}
